import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { salaryList } from '../../../action/jobs'
import { generateSearch, highestQualification, searchKeywords, searchlocations } from '../../../action/databaseSearch'
import { validateFunctionalForm } from '../../../utils'
import constant from '../../../constant'
import Modal from '../../Common/Modal'
import Multiselect from 'multiselect-react-dropdown'
const Index = () => {
    const history = useHistory();
    const [generated, setGenerated] = useState(false)
    const [jdState, setJDState] = useState({
        job_description: { name: 'job_description', value: '', isRequired: true, error: '' },
    });

    const [state, setState] = useState({
        experience: { name: 'experience', value: 'both', isRequired: false, error: '' },
        keywords: { name: 'keywords', value: [], options: [], ai_options: [], isRequired: false, error: '' },
        location: { name: 'location', value: [], options: [], isRequired: false, error: '' },
        experience_min: {
            name: "experience_min",
            value: "",
            isRequired: false,
            error: "",
            options: [
                { EXPERIENCE: "0", EXPERIENCE_DETAILS: "Fresher" },
                { EXPERIENCE: "1", EXPERIENCE_DETAILS: "1 Year" },
                { EXPERIENCE: "2", EXPERIENCE_DETAILS: "2 Years" },
                { EXPERIENCE: "3", EXPERIENCE_DETAILS: "3 Years" },
                { EXPERIENCE: "4", EXPERIENCE_DETAILS: "4 Years" },
                { EXPERIENCE: "5", EXPERIENCE_DETAILS: "5 Years" },
                { EXPERIENCE: "6", EXPERIENCE_DETAILS: "6 Years" },
                { EXPERIENCE: "7", EXPERIENCE_DETAILS: "7 Years" },
                { EXPERIENCE: "8", EXPERIENCE_DETAILS: "8 Years" },
                { EXPERIENCE: "9", EXPERIENCE_DETAILS: "9 Years" },
                { EXPERIENCE: "10", EXPERIENCE_DETAILS: "10 Years" },
                { EXPERIENCE: "12", EXPERIENCE_DETAILS: "12 Years" },
                { EXPERIENCE: "15", EXPERIENCE_DETAILS: "15 Years" },
                { EXPERIENCE: "20", EXPERIENCE_DETAILS: "20 Years" },
                { EXPERIENCE: "25", EXPERIENCE_DETAILS: "25 Years" },
                { EXPERIENCE: "30", EXPERIENCE_DETAILS: "30+ Years" }
            ]
        },
        experience_max: {
            name: "experience_max",
            value: "",
            isRequired: false,
            error: "",
            options: [
                { EXPERIENCE: "1", EXPERIENCE_DETAILS: "1 Year" },
                { EXPERIENCE: "2", EXPERIENCE_DETAILS: "2 Years" },
                { EXPERIENCE: "3", EXPERIENCE_DETAILS: "3 Years" },
                { EXPERIENCE: "4", EXPERIENCE_DETAILS: "4 Years" },
                { EXPERIENCE: "5", EXPERIENCE_DETAILS: "5 Years" },
                { EXPERIENCE: "6", EXPERIENCE_DETAILS: "6 Years" },
                { EXPERIENCE: "7", EXPERIENCE_DETAILS: "7 Years" },
                { EXPERIENCE: "8", EXPERIENCE_DETAILS: "8 Years" },
                { EXPERIENCE: "9", EXPERIENCE_DETAILS: "9 Years" },
                { EXPERIENCE: "10", EXPERIENCE_DETAILS: "10 Years" },
                { EXPERIENCE: "12", EXPERIENCE_DETAILS: "12 Years" },
                { EXPERIENCE: "15", EXPERIENCE_DETAILS: "15 Years" },
                { EXPERIENCE: "20", EXPERIENCE_DETAILS: "20 Years" },
                { EXPERIENCE: "25", EXPERIENCE_DETAILS: "25 Years" },
                { EXPERIENCE: "30", EXPERIENCE_DETAILS: "30+ Years" }
            ]
        },
        salary_min: { name: 'salary_min', value: '', options: [], isRequired: false, error: '' },
        salary_max: { name: 'salary_max', value: '', options: [], isRequired: false, error: '' },
        education: { name: 'education', value: [], options: [], isRequired: false, error: '' },
    })
    useEffect(() => {
        salaryList()
            .then((res) => {
                if (res.status) {
                    console.log(JSON.stringify(res.result))
                    setState((prevState) => ({
                        ...prevState,
                        salary_min: {
                            ...prevState.salary_min,
                            options: res.result,
                        },
                        salary_max: {
                            ...prevState.salary_max,
                            options: res.result,
                        }
                    }));
                } else {
                    console.error(res.error);
                }
            })
            .catch((err) => {
                console.error(err);
            });

        highestQualification().then((res) => {
            if (res.status) {
                console.log(JSON.stringify(res.result))

                setOptions('education', res.result)
            }
        })

    }, [])
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: value.trim() === '' && prevState[name].isRequired ? 'This field is required' : ''
            },
        }));
    };

    const setOptions = (name, newOptions) => {
        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                options: newOptions,
            },
        }));
    };

    const onGenerateSearch = () => {
        debugger
        setGenerated('loading')
        if (validateFunctionalForm(jdState, setJDState)) {
            generateSearch({ job_description: jdState.job_description.value, salary_range: state.salary_min.options, education_options: state.education.options }).then((res) => {
                if (res) {
                    setState((prevState) => ({
                        ...prevState,
                        ['keywords']: {
                            ...prevState['keywords'],
                            value: res.keywords.map((item) => {
                                return { keyword: item }
                            }),
                        },
                        ['location']: {
                            ...prevState['location'],
                            value: res.location.map((item) => {
                                return { location: item }
                            }),
                        },
                        ['experience']: {
                            ...prevState['experience'],
                            value: res.experience,
                        },
                        ['experience_min']: {
                            ...prevState['experience_min'],
                            value: isNaN(res.experience_min) ? '' : res.experience_min,
                        },
                        ['experience_max']: {
                            ...prevState['experience_max'],
                            value: isNaN(res.experience_max) ? '' : res.experience_max,
                        },
                        ['salary_min']: {
                            ...prevState['salary_min'],
                            value: isNaN(res.salary_min) ? '' : res.salary_min,
                        },
                        ['salary_max']: {
                            ...prevState['salary_max'],
                            value: isNaN(res.salary_max) ? '' : res.salary_max,
                        },
                        ['education']: {
                            ...prevState['education'],
                            value: res.education,
                        },
                    }));
                    setGenerated(true)
                }
                else {
                    setGenerated(false)
                }
            })
        }
    }
    const onSearch = (e) => {
        // e.preventDefault()
        if (validateFunctionalForm(state, setState)) {
            const model = {
                keyword: state.keywords.value.map((item) => item.keyword),
                location: state.location.value.map((item) => item.location),
                experience: state.experience.value,
                experience_min: state.experience_min.value,
                experience_max: state.experience_max.value,
                salary_min: state.salary_min.value,
                salary_max: state.salary_max.value,
                education: state.education.value,
            }
            history.push({
                pathname: constant.component.databaseSearchList.url,
                state: model
            });

        }
    }
    return (
        <React.Fragment>
            <Modal
                isOpen={generated === 'loading'}
            >
                Generating best search criteriafor you
            </Modal>
            {generated === true ? <React.Fragment>
                <div className="mb-3">
                    <label className="form-label">Searching for *</label>
                    <div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={state.experience.name}
                                id="freshersOnly"
                                value="freshers"
                                checked={state.experience.value === "freshers"}
                                onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="freshersOnly">
                                Freshers only
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={state.experience.name}
                                id="experiencedOnly"
                                value="experienced"
                                checked={state.experience.value === "experienced"}
                                onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="experiencedOnly">
                                Experienced only
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={state.experience.name}
                                id="both"
                                value="both"
                                checked={state.experience.value === "both"}
                                onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="both">
                                Both
                            </label>
                        </div>
                    </div>
                </div>
                <div className="mb-3">
                    <label htmlFor="keywords" className={`${styles['ct-label']} form-lable`}>
                        Keywords *
                    </label>
                    <Multiselect
                        placeholder='Enter keywords such as job title, skills, etc.'
                        className={state.keywords.error.length > 0 ? "is-invalid" : ''}
                        style={{
                            optionContainer:
                                state.keywords.options.length > 0 ? { display: 'block' } : { display: 'none' }
                        }}
                        options={state.keywords.options}
                        onSelect={(selectedValue) => {
                            setState((prevState) => ({
                                ...prevState,
                                keywords: {
                                    ...prevState.keywords,
                                    value: selectedValue,
                                },
                            }));


                        }}

                        onSearch={(value) => {
                            searchKeywords(value).then(res => {
                                if (res.status) {
                                    setOptions('keywords', res.result)
                                }
                            })
                        }
                        }
                        selectedValues={state.keywords.value}
                        displayValue={"keyword"}
                        name={state.keywords.name}
                        id="keywords"
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="presentCity" className={`${styles['ct-label']} form-lable`}>
                        Present City *
                    </label>
                    <Multiselect
                        placeholder='Enter city'
                        className={state.location.error.length > 0 ? "is-invalid" : ''}
                        style={{
                            optionContainer:
                                state.location.options.length > 0 ? { display: 'block' } : { display: 'none' }
                        }}
                        options={state.location.options}
                        onSelect={(selectedValue) => {
                            setState((prevState) => ({
                                ...prevState,
                                ['location']: {
                                    ...prevState['location'],
                                    value: selectedValue,
                                }
                            }));

                        }}

                        onSearch={(value) => {
                            searchlocations(value).then(res => {
                                if (res.status) {
                                    setOptions('location', res.result)
                                }
                            })
                        }
                        }
                        selectedValues={state.location.value}
                        displayValue={"location"}
                        name={state.keywords.name}
                        id="presentCity"
                    />
                </div>
                {state.experience.value !== 'freshers' &&
                    <React.Fragment>
                        <div className="mb-3">
                            <label className={`${styles['ct-label']} form-label`}>Experience *</label>
                            <div className="row">
                                {/* Min Experience */}
                                <div className="col">
                                    <select
                                        className={state.experience_min.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                        name={state.experience_min.name}
                                        value={state.experience_min.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">Min experience</option>
                                        {state.experience_min.options
                                            ?.filter((item) => !(state.experience.value === "experienced" && item.EXPERIENCE === "0")) // Hide Fresher option
                                            .map((item, index) => (
                                                <option key={index} value={item.EXPERIENCE}>
                                                    {item.EXPERIENCE_DETAILS}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                {/* Max Experience */}
                                <div className="col">
                                    <select
                                        className={state.experience_max.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                        name={state.experience_max.name}
                                        value={state.experience_max.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">Max experience</option>
                                        {state.experience_max.options?.map((item, index) => {
                                            if (Number(item.EXPERIENCE) > Number(state.experience_min.value))
                                                return (
                                                    <option key={index} value={item.EXPERIENCE}>
                                                        {item.EXPERIENCE_DETAILS}
                                                    </option>
                                                );
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>


                        <div className="mb-3">
                            <label className={`${styles['ct-label']} form-lable`}>Annual Salary *</label>
                            <div className="row">
                                <div className="col">
                                    <select
                                        className={state.salary_min.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                        name={state.salary_min.name}
                                        value={state.salary_min.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">
                                            Min Annual Salary
                                        </option>
                                        {state.salary_min.options.length > 0 &&
                                            state.salary_min.options.map((item, index) => (
                                                <option key={index} value={item.SALARY}>
                                                    {item.SALARY_DETAILS}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col">
                                    <select
                                        className={state.salary_max.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                        name={state.salary_max.name}
                                        value={state.salary_max.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">
                                            Max Annual Salary
                                        </option>
                                        {state.salary_max.options.length > 0 &&
                                            state.salary_max.options.map((item, index) => {
                                                if (Number(item.SALARY) > Number(state.salary_min.value))
                                                    return (
                                                        <option key={index} value={item.SALARY}>
                                                            {item.SALARY_DETAILS}
                                                        </option>
                                                    );
                                            })}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>

                }
                <div className="mb-3">
                    <label className={`${styles['ct-label']} form-label`}>Education Qualifications</label>
                    <div className="d-flex flex-wrap gap-2">
                        {state.education.options.map((qualification) => {
                            const isSelected = state.education.value.includes(qualification.QUALIFICATION_ID);

                            return (
                                <button
                                    type="button"
                                    key={qualification.QUALIFICATION_ID}
                                    className={`${isSelected ? styles['selected-edu'] : styles['select-edu']} btn`}
                                    onClick={() => {
                                        setState((prevState) => {
                                            const updatedEducation = isSelected
                                                ? prevState.education.value.filter(id => id !== qualification.QUALIFICATION_ID) // Remove
                                                : [...prevState.education.value, qualification.QUALIFICATION_ID]; // Add

                                            return {
                                                ...prevState,
                                                education: { ...prevState.education, value: updatedEducation }
                                            };
                                        });
                                    }}
                                >
                                    {qualification.QUALIFICATION_NAME} &nbsp;
                                    {isSelected ? (
                                        // Cross icon (Remove)
                                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5 5L15 15" stroke="#5E6C84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                            <path d="M15 5L5 15" stroke="#5E6C84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        </svg>
                                    ) : (
                                        // Plus icon (Add)
                                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 4.16666V15.8333" stroke="#5E6C84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                            <path d="M4.16602 10H15.8327" stroke="#5E6C84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        </svg>
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>

                <div className="d-flex justify-content-end gap-2">
                    <button type="reset" className={`${styles['reset-btn']} btn`}> Reset </button>
                    <button type="submit" className={`${styles['search-btn']} btn`}
                        onClick={onSearch}
                    > Search </button>
                </div>
            </React.Fragment> : <React.Fragment>
                <div className={`${styles['jobz-box']}`}>
                    <h1 className={`${styles['hi-text']} mb-0 un-yellow`}>Hello I am <span className={`${styles['hi-title']} un-blue`}>Giri <span className='un-yellow'>AI</span></span></h1>
                    <p className={`${styles['jobz-info']}`}>
                        Give me your requirement for hiring by simply writing or pasting and I’ll
                        help you to set up the tailored search as per your need with the best
                        matching profile to filter out from our database pool.
                    </p>
                </div>

                <div className="mt-4">
                    <div className="mb-3">
                        <label htmlFor="jobDescription" className={`${styles['ct-label']} form-lable`}>Job Description:</label>
                        <textarea
                            id="jobDescription"
                            className={jdState.job_description.error && !jdState.job_description.value ? "form-control is-invalid" : "form-control"}
                            rows="5"
                            placeholder="Enter the job description here..."
                            name={jdState.job_description.name}
                            value={jdState.job_description.value}
                            onChange={(e) => {
                                const { name, value } = e.target;
                                setJDState((prevState) => ({
                                    ...prevState,
                                    [name]: {
                                        ...prevState[name],
                                        value: value,
                                        error: value.trim() === '' && prevState[name].isRequired ? 'This field is required' : ''
                                    },
                                }));
                            }}
                        />
                        <div className="text-end text-muted small">240/500 Characters Left</div>
                    </div>

                    {/* <div className="mb-3">
                    <label htmlFor="jobFile" className={`${styles['ct-label']} form-lable`}>Upload Job Description</label>
                    <div className={`${styles['choose-box']} my-2`}>
                        <input
                            type="file"
                            id="jobFile"
                            className="form-control"
                            accept=".pdf, .doc, .docx, .txt"
                        />
                        <div className="form-text">
                            Only support PDF, Doc, Docx, TXT and files less than 5 MB.
                        </div>
                    </div>
                </div>

                <div className="text-center">
                    <button type="submit" className="btn btn-primary">Browse Files</button>
                </div> */}
                </div>
                <div className="d-flex justify-content-end gap-2">
                    <button type="reset" className={`${styles['reset-btn']} btn`}> Reset </button>
                    <button type="submit" className={`${styles['search-btn']} btn`}
                        onClick={() => { onGenerateSearch() }}
                    > Search </button>
                </div>
            </React.Fragment>
            }


        </React.Fragment>
    )
}

export default Index